import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

import { domChanges } from '@app/shared/utils/utils';
import { AuthService } from '@services/auth/auth.service';
import { Logger } from '@services/logger/logger.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardPublicService implements CanActivate {
  private readonly logger = new Logger('AuthGuardPublicService');

  constructor(private authService: AuthService) {}

  async canActivate(): Promise<boolean> {
    const hasAdfsSession = await this.authService.hasSession();

    await domChanges(1000); // Await until browser closes
    const ready = this.authService.isLoggedIn() || (await this.authService.hasActivo2Session());
    return ready || hasAdfsSession;
  }
}
